import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import VesselAdminMasterContent from "../../components/Masters/VesselAdminMaster/VesselAdminMasterContent";
import { getVesselMasterList } from "../../redux/actions/mastersAction";

const VesselAdminMaster = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getVesselMasterList({
        active: "true",
        searchByFirstName: "",
        limit: "",
        offset: "",
      })
    );
  }, []);
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <VesselAdminMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default VesselAdminMaster;
